"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIcon = void 0;
const react_1 = __importDefault(require("react"));
const FIcon = ({ image, className, width = 20, onClick, children }) => {
    return (react_1.default.createElement("div", { className: `f-icon f-icon-color ${className} ${onClick ? "cursor-pointer" : ""}`, onClick: onClick }, image ? react_1.default.createElement("img", { src: image, alt: "icon", width: width }) : children));
};
exports.FIcon = FIcon;
//# sourceMappingURL=Ficon.js.map